import { combineReducers } from 'redux';

import consultaTransferenciaMunicipal from './consultaTransferenciaMunicipal/reducer';
import gerarRenach from './gerarRenach/reducer';

export default combineReducers({
	consultaTransferenciaMunicipal,
	gerarRenach,
});
